import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { InactivityService } from './auth/inactivity.service';
import { FireBaseServiceService } from './core/services/firebaseService/fire-base-service.service';
import { OneSignalService } from './core/services/one-signal-service/one-signal.service';

@Component({
	selector: 'app-root',
	standalone: true,
	imports: [RouterOutlet],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {

	title = 'EdTech';
	routerSubscription = new Subscription();

	constructor(
		private router: Router,
		private _inactiveService: InactivityService,
		private _fireBaseService: FireBaseServiceService,
		private _oneSignalService: OneSignalService,
	) { }

	ngOnInit(): void {
		this.initPush();
		this._inactiveService.setAuthContextFromUrl(window.location.pathname + window.location.search);

		const token = localStorage.getItem('token');

		if (token) {
			this._inactiveService.initListener();
		}

		this.routerSubscription = this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe((event: any) => {
				this._inactiveService.setAuthContextFromUrl(event.urlAfterRedirects);
				this.showChatBot(event.urlAfterRedirects);
			});
	}

	initPush(): void {
		if (!('serviceWorker' in navigator) || !('Notification' in window)) {
			console.warn('[APP] Push notifications not supported in this browser.');
			return;
		}

		// Register the Firebase messaging service worker FIRST,
		// then get the FCM token once the SW is activated.
		// Without explicit registration, getFCMToken() times out on staging (nginx).
		navigator.serviceWorker
			.register('/firebase-messaging-sw.js', { scope: '/' })
			.then((registration) => {
				console.log('[APP] Firebase SW registered, state:', registration.active?.state ?? 'installing');
				// Give the SW a moment to activate before requesting the token
				setTimeout(() => {
					this._fireBaseService.getFCMToken();
				}, 1000);
			})
			.catch((err) => {
				console.error('[APP] Firebase SW registration failed:', err);
				// Still attempt token fetch — may succeed if SW was previously registered
				setTimeout(() => {
					this._fireBaseService.getFCMToken();
				}, 1500);
			});

		// OneSignal initialises independently
		try {
			this._oneSignalService.oneSignal();
		} catch (error) {
			console.error('[APP] OneSignal init error:', error);
		}
	}

	showChatBot(url: string) {
		const showOn = [
			'/teacher-dashboard/teacher-dashboard-content',
			'/student-dashboard/student-dashboard-content'
		];

		const shouldShow = showOn.some(route => url.includes(route));

		if (shouldShow) {
			(window as any).Tawk_API?.showWidget?.();
		} else {
			(window as any).Tawk_API?.hideWidget?.();
		}
	}

	ngOnDestroy(): void {
		this.routerSubscription?.unsubscribe();
		this._inactiveService.stop();
	}
}